/* eslint-disable camelcase */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 言語jsonファイルのimport
import translation_en from "./en-US.json";
import translation_ja from "./ja-JP.json";
import translation_zh from "./zh-CN.json";
import translation_zh_TW from "./zh-TW.json";
import translation_ko from "./ko-KR.json";
import translation_vi from "./vi-VN.json";
import { locationList } from "~/AtomWithDynamoDB";

const resources = {
  "ja-JP": {
    translation: translation_ja,
  },
  "en-US": {
    translation: translation_en,
  },
  "zh-CN": {
    translation: translation_zh,
  },
  "zh-TW": {
    translation: translation_zh_TW,
  },
  "ko-KR": {
    translation: translation_ko,
  },
  "vi-VN": {
    translation: translation_vi,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: "ja-JP", // デフォルト言語
  fallbackLng: "en-US", // 言語が見つからない場合のフォールバック
  interpolation: {
    escapeValue: false, // React では XSS 対策は不要
    defaultVariables: {
      LOCATION_JA_NAME: locationList.jaName,
      LOCATION_EN_NAME: locationList.enName,
    },
  },
});

export default i18n;
